import personaService from '@/servicios/persona'
import { ERROR_OBTENER_DATOS_PERSONA } from '@/utilidades/errores'

export const GuardaFirmaAutografaDigitalMixin = {
  data: () => ({
    consumiendoPersona: true,
  }),
  methods: {
    // Metodos publicos
    GuardaFirmaAutografaDigital(request) {
      this.$_GuardaFirmaAutografaDigitalMixin_IniciaGuardaFirmaAutografaDigital()
      return personaService
        .guardarFirmaAutografaDigital(request)
        .then((result) => {
          this.$_GuardaFirmaAutografaDigitalMixin_TerminaGuardaFirmaAutografaDigital()
          if (result.status != 200) {
            this.errorGuardaFirmaAutografaDigital(ERROR_OBTENER_DATOS_PERSONA)
            throw new Error(ERROR_OBTENER_DATOS_PERSONA)
          }

          const data = result.data
          if (!data || data.Codigo != 200 || data.Estado !== true) {
            const mensaje =
              (data &&
                (data.Mensaje || (data.Modelo && data.Modelo.Mensaje))) ||
              ERROR_OBTENER_DATOS_PERSONA
            this.errorGuardaFirmaAutografaDigital(mensaje)
            throw new Error(mensaje)
          }

          this.postGuardaFirmaAutografaDigital(data.Modelo)
          return data
        })
        .catch((err) => {
          this.$_GuardaFirmaAutografaDigitalMixin_TerminaGuardaFirmaAutografaDigital()
          console.error(err)
          this.errorGuardaFirmaAutografaDigital(ERROR_OBTENER_DATOS_PERSONA)
          throw err
        })
    },
    postGuardaFirmaAutografaDigital() {},
    errorGuardaFirmaAutografaDigital(mensaje) {
      console.error(mensaje)
    },

    // Metodos privados
    $_GuardaFirmaAutografaDigitalMixin_IniciaGuardaFirmaAutografaDigital() {
      this.consumiendoPersona = true
    },
    $_GuardaFirmaAutografaDigitalMixin_TerminaGuardaFirmaAutografaDigital() {
      this.consumiendoPersona = false
    },
  },
}
